module.exports = __webpack_public_path__ + "img/santen.0347619e.png";